import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory, Link } from "react-router-dom";


const Header = (props) => {
  const history=useHistory();
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon" onClick={()=>{history.push("/")}}></img>
        </Box>  
        {props.children}
        { 
          props.hasHiddenAuthButtons
        ? (<Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={()=>{history.push("/")}}
          >
          Back to explore
          </Button>)
          : (<div>
              { props.isUserLoggedIn
              ? (
                <Box>
                  <Stack direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  >
                <Avatar src= "public/avatar.png" alt={props.passedUserName}/>
                <h5 className ="login-name">{props.passedUserName}</h5>
                <Button variant="text" onClick={props.passedLogoutfunction}>LOGOUT </Button>
                </Stack >
                </Box>
                )
              : (<div>
                <Button variant="text" onClick={()=>{history.push("/login")}}>LOGIN</Button>
                <Button variant="contained" onClick={()=>{history.push("/register")}}>REGISTER </Button>
              </div>)
           }
            </div>
            
          ) 
          
        }
        
        
        
      </Box>
    );
};

export default Header;


